import React from 'react';
import Editor from '@monaco-editor/react';
import { useFileEditor } from '../hooks/useFileEditor';
import '../App.css';

const TextEditor = () => {
  const {
    currentFile,
    code,
    hasUnsavedChanges,
    handleCodeChange,
    saveFile,
    goToDashboard,
  } = useFileEditor('');

  const editorOptions = {
    autoIndent: 'full',
    fontFamily: 'JetBrains Mono, Fira Code, monospace',
    fontSize: 14,
    lineHeight: 22,
    minimap: { enabled: false },
    automaticLayout: true,
    scrollBeyondLastLine: false,
    padding: { top: 12, bottom: 12 },
    wordWrap: 'on',
  };

  return (
    <div id="app-root" style={{ height: '100vh' }}>
      <div id="main">
        <div id="topbar">
          <div id="title">
            <img
              id="logo"
              src="https://raw.githubusercontent.com/1lakshy/1lakshy/main/codii_logo_trans.png"
              alt="logo"
              onClick={goToDashboard}
              style={{ cursor: 'pointer' }}
              title="Back to Dashboard"
            />
            {currentFile && (
              <span style={{ marginLeft: '10px', fontSize: '14px', color: '#888' }}>
                {currentFile.name} {hasUnsavedChanges && '*'}
              </span>
            )}
          </div>
          <div id="actions">
            {currentFile && (
              <button
                onClick={saveFile}
                style={{
                  marginRight: '8px',
                  background: hasUnsavedChanges ? '#00d084' : '#555',
                }}
              >
                {hasUnsavedChanges ? 'Save *' : 'Save'}
              </button>
            )}
          </div>
        </div>

        <div style={{ height: 'calc(100vh - 60px)' }}>
          <Editor
            height="100%"
            language="plaintext"
            theme="vs-dark"
            value={code}
            onChange={handleCodeChange}
            options={editorOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default TextEditor;
